import { Box, Skeleton, type SkeletonProps } from '@/ui';

const props: SkeletonProps = {
  borderRadius: 'lg',
  aspectRatio: 3000 / 600,
  _notFirst: {
    mt: '3',
  },
};

export const LoadingState = () => {
  return (
    <Box flex="1" px="6">
      <Skeleton {...props} />
      <Skeleton {...props} />
      <Skeleton {...props} />
    </Box>
  );
};
